import React from 'react';
import List from '@material-ui/core/List';
import Item from './Link';

function Navbar({ routes }) {
  const items = routes
    .filter(el => (typeof el.showInNav !== 'undefined' ? el.showInNav : true))
    .map(el => <Item key={el.name} item={el} />);

  const element = (
    <nav>
      <List>
        {items}
      </List>
    </nav>
  );
  return element;
}

export default Navbar;
